document.addEventListener("DOMContentLoaded", function () {
    var products = document.querySelectorAll('.recommended-product');

    for (let i = 0; i < products.length; i++) {
         let button = products[i].querySelector('.learn-more');

         button.addEventListener("click", function() {

            console.log('Learn More Clicked')
            var refCode = products[i].dataset.refCode;
            var productName = products[i].dataset.name;
            var productTrackingData = TrackingDataFactory.createProductTrackingData(refCode, productName);
            productTrackingData["SkipRecommendations"] = true;
            var recommendationId = products[i].dataset.recommendation;

            if (recommendationId > 0)
            {
                productTrackingData["recommendationId"] = recommendationId;
            }

            epiRecommendations.track(productTrackingData);
         });
    }
    var recentlyOrderedProducts = document.querySelectorAll('.recently-ordered-product');

    for (let i = 0; i < recentlyOrderedProducts.length; i++) {
        let button = recentlyOrderedProducts[i].querySelector('.add-to-cart');

        button.addEventListener("click", function () {

            var refCode = recentlyOrderedProducts[i].dataset.refCode;
            var productName = recentlyOrderedProducts[i].dataset.name;
            var productTrackingData = TrackingDataFactory.createProductTrackingData(refCode, productName);
            productTrackingData["SkipRecommendations"] = true;
            var recommendationId = recentlyOrderedProducts[i].dataset.recommendation;

            if (recommendationId > 0) {
                productTrackingData["recommendationId"] = recommendationId;
            }

            epiRecommendations.track(productTrackingData);
        });
    }
});